import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';


declare global {
  interface HTMLElementTagNameMap {
    'pc-header': PcHeader;
  }
}

@customElement('pc-header')
export class PcHeader extends DeesElement {
  @property()
  public sitename = 'playcontrol.io';

  constructor() {
    super();
  }

  public render(): TemplateResult {
    
    return html`
      <style>
        :host {
          display: block;
          height:100px;
        }
        :host([hidden]) {
          display: none;
        }

        .headerMain {

        }
      </style>
      <div class="headerMain">${this.sitename}</div>
      <slot></slot>
    `;
  }

}
